// src/firebase.js
import { initializeApp } from "firebase/app";
import { getFirestore } from "firebase/firestore";
import { getStorage } from "firebase/storage";
import { getDatabase } from 'firebase/database';
import { getAuth, signInAnonymously } from "firebase/auth";

const firebaseConfig = {
    apiKey: "AIzaSyBBPYKlnbtTHWH4HgT7zHS_sJU7ZHqWraI",
    authDomain: "thesustain-44094.firebaseapp.com",
    projectId: "thesustain-44094",
    storageBucket: "thesustain-44094.firebasestorage.app",
    messagingSenderId: "426931903184",
    appId: "1:426931903184:web:3f4c3ac6789f1eea7d1cd5",
    measurementId: "G-V8GBZ6DPFG"
};

const app = initializeApp(firebaseConfig);
export const db = getFirestore(app);
export const storage = getStorage(app);
export const  rtdb = getDatabase(app);  // 👈 C'est ça qu'on importe dans ton composant
export const auth = getAuth(app);

export const COLLECTIONS = {
    SUJETS_PRIERES: "sujets_prieres",
    INTERCESSIONS: "intrcession_prieres",
    PRAYER_SESSIONS: "sessions_prieres",
    INTERCESSION_REQUESTS: "intrcession_requests",
    CHATS: "chats",
    SITEWEB_MENU: "siteweb_menu",
    SITEWEB_FLATMENU: "siteweb_flatmenu",
    SITEWEB_MENU_COLORS: "siteweb_menu_colors",
    PAGE_META_DATA: "page_meta_data",
    PAGE_MANES_LIST: "page_manes_list",
    PAGE_DATA_LIST: "page_data_list",
    CONTENT_PAGE_MODEL_DATA: "content_page_model_data",
    SITE_HEADER_FOOTER_MODEL: "site_header_footer_model",
    CATEGORIES_PRIERES: "categories_prieres",
    INTERSESSIONS_PRIERES: "intersessions_prieres",
    EVENTS_ANNOUNCEMENTS: "events_announcements",
    SPRITUAL_ACTIVITY_CHRONOS: "spritual_activity_chronos",
    SPRITUAL_ACTIVITY_SUMMARY: "spritual_activity_summary",
    SPRITUAL_TARGETS: "spritual_targets",
    SPRITUAL_TARGETS_SUMMARY: "spritual_targets_summary",
    TASKS0: "tasks",
    TASKS: "tasks_manager_tasks",
    NOTES: "notes",
    NOTES_CATEGORIES: "notes_categories",
    TASKS_HISTORY: "tasks_manager_tasks_history",
    GALLERY_OF_MEMORIES: "gallery_of_memories",
    REACT_APP_URL_NO_COLLECTION: "https://thesustain.net",
    APPNAME: "The Sustain",
    BACKEND_APP_URL_NO_COLLECTION: "https://dashboard.thesustain.net/",
    DONATION_APP_URL_NO_COLLECTION: "https://thesustain.assoconnect.com/collect/description/555345-u-adhesion-a-thesustain",
    REACT_APP_STRIPE_PUBLIC_KEY:"pk_test_51SCa8REHViWHBosKuUOtqwfPEYEGPwSXAKQNaLGEDuUosjGkYoiwUH50ZeBZlgoihfhW4VPnE5CFvzSOy3qNTjGg00wPXT3knn",
    MY_SECRET_KEY:"pk_test_jGg00wPXT3knn",
    PAYMENTS: "payments",
    INVOICES: "invoices",
    SERVICES: "services",
    PAYMENT_SERVICES: "payment_services" // Services que mon app vend
};


// Authentification anonyme automatique
signInAnonymously(auth)
    .then(() => {
        console.log("✅ Connecté anonymement à Firebase");
    })
    .catch((error) => {
        console.error("❌ Erreur de connexion anonyme :", error);
    });


